<div class="paper brief-fax-table">
  <div class="brief-fax-table__head">
    <h4 class="brief-fax-table__head-cell">Status</h4>
    <h4 class="brief-fax-table__head-cell">Date</h4>
    <h4 class="brief-fax-table__head-cell">Number</h4>
    <h4 class="brief-fax-table__head-cell">Pages</h4>
    <h4 class="brief-fax-table__head-cell">Folder</h4>
  </div>

  <div *ngIf="isLoading; else content" class="brief-fax-table__body">
    <div *ngFor="let row of skeletonRows" class="brief-fax-table__body-row">
      <span class="skeleton brief-fax-table__status-icon"></span>
      <span class="skeleton brief-fax-table__skeleton-cell"></span>
      <span class="skeleton brief-fax-table__skeleton-cell"></span>
      <span class="skeleton brief-fax-table__skeleton-cell"></span>
      <span class="skeleton brief-fax-table__skeleton-cell"></span>
    </div>
  </div>

  <ng-template #content>
    <div *ngIf="doesFaxesExist; else placeholder" class="brief-fax-table__body">
      <div *ngFor="let fax of faxes" class="brief-fax-table__body-row" (click)="rowClick.emit(fax.id)">
        <div>
          <img [src]="getStatusIconSrc(fax.status)" [alt]="fax.status" class="brief-fax-table__status-icon" />
        </div>

        <p class="brief-fax-table__date-wrapper">
          <span *ngFor="let datePart of splitDateTime(fax.createdAt)">
            {{ datePart }}
          </span>
        </p>

        <p>{{ fax.toNumber }}</p>

        <p>{{ fax.pages }}</p>

        <p [title]="getFolderName(fax.folderId)">{{ getFolderName(fax.folderId) | truncate: 10 }}</p>
      </div>
    </div>

    <ng-template #placeholder>
      <div class="brief-fax-table__placeholder">
        <p>{{ placeholderText }}</p>
      </div>
    </ng-template>
  </ng-template>
</div>
